const SRC = { pf: "/brand/pf-logo.png", uwl: "/brand/uwl-logo.png", charter: "/brand/charter-hcp.png", albion: "/brand/albion-dominion.png" };

const toData = (src) => new Promise((res) => {
  const img = new Image();
  img.onload = () => {
    const c = document.createElement("canvas");
    c.width = img.naturalWidth;
    c.height = img.naturalHeight;
    c.getContext("2d").drawImage(img, 0, 0);
    res({ data: c.toDataURL("image/png"), r: img.naturalWidth / img.naturalHeight });
  };
  img.onerror = () => res(null);
  img.src = src;
});

export const loadBrand = async () => Object.fromEntries(await Promise.all(Object.entries(SRC).map(async ([k, s]) => [k, await toData(s)])));

export const PAGE_TOP = 30;
export const PAGE_BOTTOM = 266;

export const brandPages = (doc, brand, title) => {
  const n = doc.getNumberOfPages();
  const img = (k, x, y, h) => {
    const b = brand[k];
    if (!b) return 0;
    doc.addImage(b.data, "PNG", x, y, h * b.r, h);
    return h * b.r;
  };
  for (let i = 1; i <= n; i += 1) {
    doc.setPage(i);
    img("pf", 18, 9, 8);
    doc.setFont("helvetica", "normal").setFontSize(7.5).setTextColor(107, 124, 136).text(title, 192, 13, { align: "right" });
    doc.setDrawColor(31, 138, 139).setLineWidth(0.3).line(18, 20, 192, 20).line(18, 273, 192, 273);
    doc.text("In partnership with", 18, 277);
    let x = 18;
    [["uwl", 7.5], ["charter", 6], ["albion", 4.8]].forEach(([k, h]) => { x += img(k, x, 279 + (7.5 - h) / 2, h) + 9; });
    doc.text(`Page ${i} of ${n}`, 192, 286, { align: "right" });
  }
};
